import session from './session'
import users from './users'
import feedbacks from './feedbacks'
import services from './services'
import experts from './experts'
import bank from './bank'
import purchases from './purchases'
import links from './links'
import metrics from './metrics'
import invitations from './invitations'
import password from './password'
import call from './call'
import transfers from './transfers'
import wallets from './wallets'
import conversations from './conversations'
import messages from './messages'
import chat from './chat'
import pauses from './pauses'
import cards from './cards'
import outcomes from './outcomes'
import minuteGifts from './minute_gifts'
import activities from './activities'

export default {
  namespaced: true,
  modules: {
    session,
    users,
    feedbacks,
    services,
    experts,
    bank,
    purchases,
    links,
    metrics,
    invitations,
    password,
    call,
    transfers,
    wallets,
    conversations,
    messages,
    chat,
    pauses,
    cards,
    outcomes,
    minuteGifts,
    activities
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/index.js